import { axiosChartInstance } from "config";
import { useAxiosMutation } from "hooks";
import { useQueryClient } from "react-query";
import { Interaction } from "types";

type IvMedicationPayloadSection = {
  code: string;
  interactions: Interaction[];
  answers: { qCode: string; value: unknown }[];
  orderId?: string;
};
type IvMedicationSections = {
  IVStarts: IvMedicationPayloadSection[];
  IVMedications: IvMedicationPayloadSection[];
  Medications: IvMedicationPayloadSection[];
  Treatments: IvMedicationPayloadSection[];
  TreatmentsIvStarts: IvMedicationPayloadSection[];
};
type IvMedicationPayload = IvMedicationSections & {
  lastSnapshotCreatedAt: string | null;
};

function useUpdateIvAndMedication(encounterId: string) {
  const queryClient = useQueryClient();
  return useAxiosMutation(
    ["updateIvAndMedication", { encounterId }],
    (input: IvMedicationPayload) =>
      axiosChartInstance.post(`v1/triage/iv-medication/${encounterId}`, input),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["ivAndMedication", { encounterId }]);
        queryClient.invalidateQueries([
          "ivAndMedicationCounters",
          { encounterId },
        ]);
        queryClient.invalidateQueries(["medsAndIvCounters", { encounterId }]);
        queryClient.invalidateQueries(["treatmentsCounters", { encounterId }]);
      },
    }
  );
}

export { useUpdateIvAndMedication };
export type {
  IvMedicationPayload,
  IvMedicationPayloadSection,
  IvMedicationSections,
};
